import type { CharacterResponse, CharacterSummary } from '../types';

const API_BASE = import.meta.env.VITE_API_BASE || '';

export async function fetchCharacter(): Promise<CharacterResponse> {
  const res = await fetch(`${API_BASE}/api/character`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

export async function fetchCharacterByKey(key: string): Promise<CharacterResponse> {
  const res = await fetch(`${API_BASE}/api/character/${encodeURIComponent(key)}`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

export async function fetchCharacters(): Promise<CharacterSummary[]> {
  const res = await fetch(`${API_BASE}/api/characters`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const data = await res.json();
  return data.characters;
}
